import { useContext, useEffect, useState } from "react";
import { actions } from "../../../store";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { PlayBackContext } from "../../../contexts";
import styles from "./WareHouse.module.css";
import { useStoreContext } from "../../../hooks/useStoreContext";
import axiosClient from "../../../services/axiosClient";
import RenderStatus from "../../../components/StatusRender";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const Camera = ({ name, status, check, camID, setCheck, message, wareHouseCode, index,setCamera,camera }) => {
  const { t } = useTranslation();
  const { cameraCode, setCameraCode, setName, setCurrentPage } = useContext(PlayBackContext);
  const [checkCamera, setCheckCamera] = useState(false);
  const companyCode = sessionStorage.getItem('company_code');
  

  // Lấy params từ URL

  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const handleGetPlayBack = (code, name, e) => {
    
      let dataAdd = {
        type: 'cam',
        add: e,
        data: [{ name: name, code: code, status: check, camStatusActive: status, hour: "00:00:00" }],
        warehouseCode: wareHouseCode
      }
      setCameraCode(code);
      setName(name);
      const checkCameraList = camera.map((item)=>{
        if(item.CODE === code){
          return {
            ...item,
            CHECK: e
          }
        }
        else {
          return item
        }
      })
      setCamera(checkCameraList)
      const wareHouseCheck = checkCameraList.every(item =>item.CHECK === true)
      setCheck(wareHouseCheck)
      dispatch(actions.getListCodeCamera(dataAdd));
    
    // setCheck(false)
  };
  useEffect(() => {
    console.log(check);
    
    setCheckCamera(check)
  }, [check]);
  const handleChoseCamera = (code) => {
    setCurrentPage(1)
    if (checkCamera) {
      dispatch(actions.getCameraCode(code));
    }
  };

  return (
    <div
      className={cx("item-cam", camID === cameraCode ? "active" : "")}
      onClick={(e) => handleChoseCamera(camID)}
    >
      <div className={cx("camera")}>
        <span className={cx("hover")}>
          <RenderStatus status={status} companyCode={companyCode} />

          <p className={cx('tooltip', index === 0 ? 'bottom' : 'top')}>
            {status === 0 ? t("playback.isOnline") :
              status === 3 ? t("playback.isReady") :
                t("playback.isLostConnect")
            }
          </p>
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
      <input
        checked={check}
        className={cx("check")}
        type="checkbox"
        onChange={(e) => handleGetPlayBack(camID, name, e.target.checked, status)}
      />
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  camID: PropTypes.string.isRequired,
};
export default Camera;
